import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADVANCE_WMS_MODULE, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ReturnedList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, show: false, showCopyButton: true },
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'deliveryName',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				renderCell: ListComponents.DC_LOGO
			},
			{
				Header: 'phone',
				accessor: 'phone',
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE
			},
			{
				Header: 'customerReturnReason',
				accessor: 'returnReasonOptions',
				filterType: FilterType.string,
				width: 90
			},
			{
				Header: 'customerReturnComment',
				accessor: 'returnReason',
				filterType: FilterType.string,
				width: 90
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'subtotal',
				accessor: 'subTotal',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'returnStatus',
				accessor: 'returnApprovalStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.RETURN_STATUS,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.WMS_RETURNED_LIST}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={ADVANCE_WMS_MODULE.GET_RETURN_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.WMS}
				exportName="otopackReturned"
			/>
		</TabTableContainer>
	);
};

export default ReturnedList;
